<template>
  <div class="shippingList">
    <!-- 新增筛选项 2021 04 25 -->
    <div class="top-filter-form">
      <el-form
        ref="filterForm"
        :model="filterForm"
        :inline="true"
        label-position="left"
      >
        <el-form-item label="订单类型">
          <el-select
            v-model="filterForm.orderType"
            placeholder="请选择订单类型"
            clearable
          >
            <el-option label="普通订单" value="0"></el-option>
            <el-option v-if="isJgj !== '1' " label="谷仓订单" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主单号">
          <el-input
            class="main-order-number-input"
            v-model="filterForm.mainOrderNumber"
            placeholder="多个主单号用英文半角’,‘隔开"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="出库时间">
          <el-date-picker
            size="mini"
            v-model="filterForm.outStockDate"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            align="right"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmitFilter" size="small"
            >查询</el-button
          >
          <el-button size="small" class="filter-reset-btn" @click="handleReset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="main print-font">
      <div class="title print-font">三方发货清单</div>
      <div class="print-font">
        <el-form :inline="true" :model="shippingForm" label-position="left">
          <el-form-item label="名称:">{{
            shippingForm.shop_name
          }}</el-form-item>
          <el-form-item label="日期:">{{ shippingForm.date }}</el-form-item>
          <div>
            <el-form-item label="收货方:">{{
              shippingForm.user_name
            }}</el-form-item>
            <el-form-item label="收货地址:">{{
              shippingForm.address
            }}</el-form-item>
            <el-form-item label="联系方式:">{{
              shippingForm.mobile
            }}</el-form-item>
          </div>
        </el-form>
        <el-table
          :data="shippingTableData"
          border
          style="width: 100%"
          :span-method="objectSpanMethod"
          show-summary
          :summary-method="getSummaries"
        >
          <el-table-column type="index" label="序号"> </el-table-column>
          <el-table-column prop="created_at" label="推送时间">
          </el-table-column>
          <el-table-column prop="main_number" label="主订单号">
          </el-table-column>
          <el-table-column prop="" label="编号">
            <template slot-scope="scope">
              <span v-if="scope.row.serial_number">{{
                scope.row.serial_number.split("-").slice(3).join("-")
              }}</span>
              <span v-if="scope.row.express && isZhifaOrFactory"
                >({{ scope.row.express }})</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="mo_statusName" label="状态"> </el-table-column>
          <el-table-column prop="weight" label="打包称重(kg)">
          </el-table-column>
          <el-table-column prop="box_num" label="打包箱数"> </el-table-column>
          <el-table-column prop="box_code" label="箱码" width="160">
            <template slot-scope="scope">
              <span v-if="scope.row.box_code">
                <span
                  style="display: block"
                  v-for="item in scope.row.box_code.split(',')"
                  :key="item"
                  >{{ item }}</span
                >
              </span>
            </template>
          </el-table-column>
          <el-table-column label="是否签收"> </el-table-column>
          <el-table-column prop="remark" label="备注"> </el-table-column>
        </el-table>
        <div class="warning-info">
          注意：签收前请查验货物，您的签名意味着货物签收确认。签收人签名：
        </div>
      </div>
    </div>
    <div class="btn">
      <el-button type="primary" size="small" @click="myPrint">打印</el-button>
    </div>
  </div>
</template>
<script>
import { getOdStatusList } from "@/utils/utils";
import { getShippingList } from "@/models/orderModel";
export default {
  data() {
    return {
      isZhifaOrFactory:
        localStorage.getItem("shop_type") === "2" ||
        localStorage.getItem("shop_type") === "1",
      isJgj: localStorage.getItem("is_jgj"),
      shippingForm: {
        address: "",
        box_num: "",
        date: "",
        mobile: "",
        shop_name: "",
        user_name: "",
        weight: "",
      },
      shippingTableData: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      filterForm: {
        orderType: "",
        mainOrderNumber: "",
        outStockDate: null,
      },
    };
  },
  mounted() {
    this.getShippingList();
  },
  methods: {
    // 筛选
    onSubmitFilter() {
      this.getShippingList();
    },
    // 重置
    handleReset() {
      Object.assign(this.filterForm, {
        ...this.filterForm,
        orderType: "",
        mainOrderNumber: "",
        outStockDate: null,
      });
      this.getShippingList();
    },
    async getShippingList() {
      let { orderType, mainOrderNumber, outStockDate } = this.filterForm;
      let filterParams = {
        order_type: orderType || "",
        start_time: outStockDate
          ? outStockDate.length > 0
            ? outStockDate[0]
            : ""
          : "",
        end_time: outStockDate
          ? outStockDate.length > 0
            ? outStockDate[1]
            : ""
          : "",
        main_number: mainOrderNumber || "",
        outware_today: localStorage.getItem("is_jgj") === "1" ? 1 : "", // 今日已出库  需要个字段
      };
      //console.log(filterParams,'filterParams')
      // let params = {
      //   order_ids: this.$route.query.id
      // }
      let data = await getShippingList(filterParams);
      //console.log(data,'出库清单列表数据')
      // this.orderDetailTableData = data.order
      // this.orderGoodsInfoData = data.goods
      this.shippingForm = data.info;
      this.shippingTableData = data.order;
      for (let i of data.order) {
        i.mo_statusName = getOdStatusList().mo_statusList.filter(
          (item) => item.value === i.mo_status
        )[0].label;
      }
    },
    myPrint() {
      let subOutputRankPrint = document.querySelector(".main");
      let newContent = subOutputRankPrint.innerHTML;
      let oldContent = document.body.innerHTML;
      document.body.innerHTML = newContent;
      window.print();
      window.location.reload();
      document.body.innerHTML = oldContent;
      return false;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      //console.log(row, column, rowIndex, columnIndex)
      // if (columnIndex === 0) {
      //   if (rowIndex % 2 === 0) {
      //     return {
      //       rowspan: 2,
      //       colspan: 1
      //     };
      //   } else {
      //     return {
      //       rowspan: 0,
      //       colspan: 0
      //     };
      //   }
      // }
      // if(row)
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        const values = data.map((item) => Number(item[column.property]));
        if (index === 0) {
          sums[index] = "合计";
          // return
        } else if (index === 6 || index === 5) {
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values
              .reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0)
              .toFixed(0);
          } else {
            sums[index] = "";
          }
        }
      });

      return sums;
    },
  },
};
</script>
<style lang="scss">
.shippingList {
  padding: 10px;
  .top-filter-form {
    margin-bottom: 40px;
    .el-form .el-form-item__label {
      width: 65px;
      white-space: nowrap;
    }
    .el-form .filter-reset-btn {
      color: #ffffff;
    }
    .main-order-number-input {
      width: 320px !important;
    }
  }
  .main {
    border: 1px solid grey;
    padding: 10px;
    .el-form-item__content {
      font-size: 12px;
    }
    .title {
      text-align: center;
      font-weight: bold;
    }
    .el-form {
      border-bottom: 1px dashed grey;
      padding-bottom: 10px;
    }
    .el-table {
      margin-top: 20px;
    }
    .warning-info {
      font-size: 12px;
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
  .btn {
    margin-top: 20px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/shippingList.vue